<template>
    <div class="create-chat-search">
        <input type="text" ref="input" @focus="onFocus" @blur="onBlur" v-model="searchString" @keyup="onKeyup">
        <div class="create-chat-search__placeholder" @click="$refs['input'].focus()" v-if="showPlaceholder">
            <lens></lens>
            {{ $t('common.search') }}
        </div>
    </div>
</template>

<script>
    import Lens from '../svg/Lens';
    import debounce from 'lodash.debounce';

    export default {
        name: "SearchBar",
        components: {Lens},
        props: {
            value: String
        },
        data() {
            return {
                searchString: '',
                showPlaceholder: true,
                previousValue: ''
            }
        },
        methods: {
            onFocus() {
                this.showPlaceholder = false;
            },
            onBlur() {
                if (this.searchString.length == 0) {
                    this.showPlaceholder = true;
                }
            },
            onKeyup: debounce(function() {
                if (this.previousValue != this.searchString) {
                    this.$emit('input', this.searchString)
                    this.previousValue = this.searchString;
                }
            }, 500)
        }

    }
</script>

<style scoped>

</style>